/*
 * @Description:
 * @Date: 2022-01-18 10:51:42
 */

export const userEnterpriseTypeMapping = {
  1: {
    label: '自然人',
    value: 1
  },
  2: {
    label: '普通个体',
    value: 2
  },
  3: {
    label: '园区个体',
    value: 3
  }
};
